var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14H9V15.5H1.5V14ZM1.5 8.75H16.5V10.25H1.5V8.75ZM1.5 3.5H16.5V5H1.5V3.5ZM13.5 14V11.75H15V14H17.25V15.5H15V17.75H13.5V15.5H11.25V14H13.5Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePlaylist);
export default __webpack_public_path__ + "static/media/create-playlist.acf012d704b8e2118f57b86ecc5bee46.svg";
export { ForwardRef as ReactComponent };